import { render, staticRenderFns } from "./ActivityHistory.vue?vue&type=template&id=27c95214&"
import script from "./ActivityHistory.vue?vue&type=script&lang=js&"
export * from "./ActivityHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports